import Helper from "../../Helper";

export class InvalidLoginAttempt extends Error {}
export class TooManyInvalidLoginAttempts extends Error {}

interface email_sms {
    mobile?: string;
    email?: string;
    return_url: string | null;
    timestamp: string;
}

export function userOTPLogin(email_sms: email_sms): Promise<any> {
    const url = "/auth/login";

    if (email_sms.mobile) {
        email_sms.mobile = email_sms.mobile.trim();
    }
    if (email_sms.email) {
        email_sms.email = email_sms.email.trim();
    }
    const options = {
        method: "post",
        body: JSON.stringify(email_sms),
    };
    return Helper.plotFetch(url, options, true)
        .then((response) => {
            if (response.ok) {
                return response.json();
            }

            throw new Error("Failed to send OTP");
        })
        .catch(() => {
            return false;
        });
}

export function userOTPPasscode(user): Promise<boolean> {
    const url = "/auth/passcode";
    const options = {
        method: "post",
        body: JSON.stringify(user),
    };
    return Helper.plotFetch(url, options, true).then((response) => {
        if (response.ok) {
            return response.json();
        }
        if (response.status === 401) {
            throw new InvalidLoginAttempt("Invalid code.");
        }
        if (response.status === 403) {
            throw new TooManyInvalidLoginAttempts("Too many invalid attempts, code has been reset.");
        }
        throw new Error("Failed to verify OTP passcode");
    });
}

export function createUser(user): Promise<boolean> {
    const url = "/signup";
    const options = {
        method: "post",
        body: JSON.stringify(user),
    };
    return Helper.plotFetch(url, options, true)
        .then((response) => {
            if (response.ok) {
                return response.json();
            }

            throw new Error("Failed to send OTP");
        })
        .catch(() => {
            return false;
        });
}
